/* global $ */
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'

function init () {
  const swiperElems = $('.slider-block .swiper-container');
  swiperElems.each(function (index, swiperElem) {
    if ($(swiperElem).length === 0) {
      return;
    }
    let loopVal = false;
    if ($(swiperElem).find('.swiper-slide').length > 2) {
      loopVal = true;
    }
    let slidesPerView = 3;
    if( $(swiperElem).attr('slidesPerView') ) {
      slidesPerView = $(swiperElem).attr('slidesPerView');
    }
    
    const swiper = new Swiper(swiperElem[0], {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      autoHeight: false,
      slidesPerView: slidesPerView,
      loop: loopVal,
      spaceBetween: 0,
      watchOverflow: true,
      centeredSlides: false,
      pagination: {
        el: $(swiperElem).closest('.slider-block').find('.swiper-pagination')[0],
        clickable: true
      },
      breakpoints: {
        1000: {
          slidesPerView: 1
        }
      }
    });

    $(swiperElem).find('a').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      window.location.href = $(this).attr('href');
    });
  });
}

export default {
  init
}